import React from 'react';
import { principles } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Philosophy = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.1);

  return (
    <section id="philosophy" className="relative py-32 lg:py-40 bg-[#0c0c10]">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          ref={headerRef}
          className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-purple-400 text-sm font-medium tracking-widest uppercase mb-4">Philosophy</p>
          <h2 className="font-display text-4xl lg:text-5xl text-white mb-6">
            No hype. No dashboards for decoration.
          </h2>
          <p className="text-white/50 text-lg">
            Durable systems. Quietly relentless. Built to scale.
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {principles.map((principle, index) => (
            <PrincipleCard key={principle.id} principle={principle} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const PrincipleCard = ({ principle, index }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <div
      ref={ref}
      className={`group p-8 border border-white/5 hover:border-purple-500/20 bg-[#050508] transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="flex items-start gap-6">
        <div className="w-12 h-12 border border-purple-500/30 flex items-center justify-center flex-shrink-0">
          <span className="text-purple-400 font-mono text-sm">0{index + 1}</span>
        </div>
        <div>
          <h3 className="text-xl text-white font-medium mb-3 group-hover:text-purple-400 transition-colors">
            {principle.title}
          </h3>
          <p className="text-white/40 leading-relaxed">{principle.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Philosophy;
